import { render, staticRenderFns } from "./DefaultFooter.vue?vue&type=template&id=d1d5455c&scoped=true&"
import script from "./DefaultFooter.vue?vue&type=script&lang=js&"
export * from "./DefaultFooter.vue?vue&type=script&lang=js&"
import style0 from "./DefaultFooter.vue?vue&type=style&index=0&id=d1d5455c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1d5455c",
  null
  
)

export default component.exports